import { createSlice } from "@reduxjs/toolkit";
import {
  AwardsData,
  AwardsInitialStatus,
} from "../../../../../types/webCms/aboutUs/awards";
import { getAllAwardsAsync, updateAwardsDataAsync } from "./awardsApi";

const initialState: AwardsInitialStatus<AwardsData> = {
  loading: false,
  manageLoading: false,
  awardsDataList: [],
  countAwardsData: 0,
};

const awardsSlice = createSlice({
  name: "admin-awards",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllAwardsAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllAwardsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.awardsDataList = action.payload.data;
        state.countAwardsData = action.payload.length;
      })
      .addCase(getAllAwardsAsync.rejected, (state) => {
        state.loading = false;
        state.awardsDataList = [];
        state.countAwardsData = 0;
      });

    // update
    builder
      .addCase(updateAwardsDataAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateAwardsDataAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateAwardsDataAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default awardsSlice;
